module.exports = __webpack_public_path__ + "static/media/header_desktop_light.2192511e.png";